export default "__VITE_PUBLIC_ASSET__b2420770__"